import { PDFDocument } from 'pdf-lib';

/**
 * PDF ファイルのページ数を取得する
 *
 * pdf-lib でファイルをパースしてページ数を返す。Worker 設定は不要。
 * 暗号化された PDF でもページ数を取得できるよう `ignoreEncryption` を有効にする。
 *
 * パースに失敗した場合（破損・非対応の PDF 等）は例外を送出する。
 * 呼び出し側でページ数バリデーションをスキップしたい場合は catch して扱うこと。
 *
 * @param file - 対象の PDF ファイル
 * @returns ページ数
 */
export const getPdfPageCount = async (file: File): Promise<number> => {
  const arrayBuffer = await file.arrayBuffer();
  const doc = await PDFDocument.load(arrayBuffer, { ignoreEncryption: true });
  return doc.getPageCount();
};
